import EventEmitter from 'eventemitter3';
import { v4 as uuidV4 } from 'uuid';
import { NotificationToastType } from '@/api/apis/communication';
import { wsDefaultConnector, WsMessageCaseType } from '@/ws';

export class ToastNotifier {
  protected readonly eventEmitter = new EventEmitter();

  constructor() {
    wsDefaultConnector.on((type, content) => {
      if (type === WsMessageCaseType.TOAST_CASE_EVENT_CREATED) {
        this.handleToastEvent(content as unknown as NotificationToastType);
      }
    });
  }

  protected handleToastEvent(message: NotificationToastType) {
    this.eventEmitter.emit(WsMessageCaseType.TOAST_CASE_EVENT_CREATED, { ...message, id: uuidV4() });
    console.log('📩 Received toast event:', JSON.stringify(message));
  }

  subscribe(handler: (message: NotificationToastType) => void) {
    this.eventEmitter.on(WsMessageCaseType.TOAST_CASE_EVENT_CREATED, handler);
    return () => this.unsubscribe();
  }

  unsubscribe() {
    this.eventEmitter.off(WsMessageCaseType.TOAST_CASE_EVENT_CREATED);
  }
}

export const toastNotifier = new ToastNotifier();
